import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Link, Outlet } from "@tanstack/react-router";
import { AppHeader } from "../components/AppHeader.tsx";
import { DropLayer } from "../components/DropLayer.tsx";
import { MoveLayer } from "../components/MoveLayer.tsx";
import { NotOwner, NotOwnerError } from "../components/NotOwner.tsx";
import { StatePanel } from "../components/StatePanel.tsx";
import { UploadTray } from "../components/UploadTray.tsx";
import ui from "../components/ui.module.css";
import { meQuery, messageOf } from "../lib/queries.ts";
import styles from "./root.module.css";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQuery);
    if (!me.owner) throw new NotOwnerError(me.email);
  },
  component: Root,
  errorComponent: ({ error }) => {
    if (error instanceof NotOwnerError) return <NotOwner email={error.email} />;
    return (
      <main className={styles.main}>
        <StatePanel icon="alert" title="Vault did not load" detail={messageOf(error)}>
          <button type="button" className={ui.button} onClick={() => window.location.reload()}>
            Reload
          </button>
        </StatePanel>
      </main>
    );
  },
  notFoundComponent: () => (
    <StatePanel icon="files" tone="info" title="No page here" detail="The address is wrong.">
      <Link to="/" className={ui.button}>
        All files
      </Link>
    </StatePanel>
  ),
});

function Root() {
  return (
    <>
      <AppHeader />
      <main className={styles.main}>
        <Outlet />
      </main>
      <UploadTray />
      <DropLayer />
      <MoveLayer />
    </>
  );
}
